import { createFileRoute } from "@tanstack/react-router";
import { fotoTopicRoute } from "@/lib/seo/fotoTopicRoute";

export const Route = createFileRoute("/foto/headshots")(fotoTopicRoute("headshots"));
